var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Block',{attrs:{"title":"Links"}},[_c('v-row',{attrs:{"dense":""}},_vm._l((_vm.items),function(item,index){return _c('Cell',{key:index,attrs:{"title":item.title,"url":item.content,"hint":item.hint}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }